import { OrderFields } from '../../helpers/hooks/useManageMyOrders'
import { CheckedOrder } from '../checkedOrders/types'
import { OrderType } from '../order/types'
import { Security } from '../securities/reducer'
import { StagedOrder } from './types'

export const addOrUpdateStagedOrders = (
  stagedOrders: StagedOrder[],
  cancelLiveOrders = false
) =>
  ({
    type: 'stagedOrders.addOrUpdateStagedOrders',
    payload: { stagedOrders, cancelLiveOrders }
  } as const)
export type AddOrUpdateStagedOrdersAction = ReturnType<
  typeof addOrUpdateStagedOrders
>

export const removeStagedOrder = (stagedOrderSecurityIdAndType: {
  securityId: Security['id']
  orderType: OrderType
}) =>
  ({
    type: 'stagedOrders.removeStagedOrder',
    payload: stagedOrderSecurityIdAndType
  } as const)
export type RemoveStagedOrderAction = ReturnType<typeof removeStagedOrder>

export const removeStagedOrders = (
  stagedOrderSecurityIdAndType: CheckedOrder[]
) =>
  ({
    type: 'stagedOrders.removeStagedOrders',
    payload: stagedOrderSecurityIdAndType
  } as const)
export type RemoveStagedOrdersAction = ReturnType<typeof removeStagedOrders>

export const removeAllStagedOrders = () =>
  ({ type: 'stagedOrders.removeAllStagedOrders' } as const)
export type RemoveAllStagedOrdersAction = ReturnType<
  typeof removeAllStagedOrders
>

export const clearCheckedStagedOrders = () =>
  ({ type: 'stagedOrders.clearCheckedStagedOrdersAction' } as const)
export type ClearCheckedStagedOrdersAction = ReturnType<
  typeof clearCheckedStagedOrders
>

export const setFocusOnOrder = (
  order:
    | { securityId: Security['id']; orderType: OrderType; isUst?: boolean }
    | undefined
) => ({ type: 'stagedOrders.setFocusOnOrder', payload: order } as const)
export type SetFocusOnOrderAction = ReturnType<typeof setFocusOnOrder>

export const setTempOrderFieldValue = (
  securityId: Security['id'],
  orderType: OrderType,
  field: OrderFields,
  tempValue: string
) =>
  ({
    type: 'stagedOrders.setTempOrderFieldValue',
    securityId,
    orderType,
    field,
    payload: tempValue
  } as const)
export type SetTempOrderFieldAction = ReturnType<typeof setTempOrderFieldValue>

export const updateWorkingOrderField = (
  field: 'size' | 'spread' | 'price',
  value: string,
  isUst: boolean = false,
  defaultSize = 100
) =>
  ({
    type: 'stagedOrders.updateWorkingOrderField',
    payload: { field, value, isUst, defaultSize }
  } as const)
export type UpdateWorkingOrderFieldAction = ReturnType<
  typeof updateWorkingOrderField
>

export type StagedOrdersAction =
  | AddOrUpdateStagedOrdersAction
  | RemoveStagedOrderAction
  | RemoveStagedOrdersAction
  | RemoveAllStagedOrdersAction
  | ClearCheckedStagedOrdersAction
  | SetFocusOnOrderAction
  | SetTempOrderFieldAction
  | UpdateWorkingOrderFieldAction
